import React from "react";
import pipaanlogo from "../../assets/pipaanlogo.png";
import newsfeed from "../../assets/images/icons/newsfeed.png";
import friendsfollowers from "../../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../../assets/images/icons/groupandfamily.png";
import chats from "../../assets/images/icons/chats.png";
import profile from "../../assets/images/icons/profile.png";
import Account from "../../assets/images/icons/account-setting.png";
import help from "../../assets/images/icons/helpandsupport.png";
import logout from "../../assets/images/icons/logout.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useLocation, useNavigate } from "react-router-dom";


export default function Leftsidebar() {
    const navigate = useNavigate(); // Initialize navigation

    const handleLogout = async () => {
        const token = sessionStorage.getItem("accessToken"); // Retrieve token from sessionStorage
        console.log("Logging out, Token:", token);

        if (!token) {
            console.warn("No token found, logging out locally...");
            clearSessionAndRedirect(navigate);
            return;
        }

        try {
            const response = await fetch("https://pipaan.com360degree.com/api/auth/logout", {
                method: "GET",
                headers: {
                    "token": `${token}`, // ✅ Ensure correct format
                    "Content-Type": "application/json",
                },
            });

            console.log("Logout API Response Status:", response.status);

            if (response.ok) {
                console.log("✅ Successfully logged out from server");
            } else {
                const errorData = await response.json();
                console.error("❌ Logout API Error:", errorData);
            }
        } catch (error) {
            console.error("❌ Logout API Request Failed:", error);
        }

        // ✅ Always clear session storage before navigating
        clearSessionAndRedirect(navigate);
    };

    // ✅ Function to clear session storage and redirect properly
    const clearSessionAndRedirect = (navigate) => { 
        sessionStorage.clear(); // ✅ Clear all session storage
        sessionStorage.removeItem("accessToken"); // ✅ Remove from localStorage
        sessionStorage.removeItem("user");
    
        console.log("User logged out, redirecting...");
    
        setTimeout(() => {
            navigate("/login", { replace: true }); // ✅ Ensure proper redirection
        }, 100); // Small delay to ensure session storage is cleared
    };


    //     const handleLogout = () => {
    //     // ✅ Remove auth token and user data from sessionStorage
    //     sessionStorage.removeItem("authToken");
    //     sessionStorage.removeItem("user");
    //     console.log("logout")
    //     // ✅ (Optional) Remove from localStorage if you stored it there
    //     localStorage.removeItem("authToken");
    //     localStorage.removeItem("user");

    //     console.log("User logged out successfully!");

    //     // ✅ Redirect to login page
    //     navigate("/login");
    //   };
    const location = useLocation(); // Get current URL
    return (

        <div className="">
        {/* Sidebar */}
        <aside className="w-80 sidebar-dashboard h-full bg-[#F4F4F4] p-6 shadow-md hidden lg:block">
          <div className="float-sticky">
            {/* Logo */}
            <div
              className="logo flex items-center justify-center space-x-2 cursor-pointer"
              onClick={() => navigate("/home")}
            >
              <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
            </div>
  
            {/* Navigation */}
            <nav className="space-y-4">
              <a
                href="/home"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/home" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={newsfeed} alt="" />
                <span>New Feeds</span>
              </a>
  
              <a
                href="/friendsfollowers"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/friendsfollowers" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={friendsfollowers} alt="" />
                <span>Friends & Followers</span>
              </a>
  
              <a
                href="/groupsfamily"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/groupsfamily" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={groupsandfamily} alt="" />
                <span>Groups & Family</span>
              </a>
  
              <a
                href="/chats"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/chats" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={chats} alt="" />
                <span>Chats</span>
              </a>
  
              <a
                href="/myprofile"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/myprofile" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={profile} alt="" />
                <span>Profile</span>
              </a>
  
              <a
                href="/account"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/account" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={Account} alt="" />
                <span>Account Settings</span>
              </a>
  
              <a
                href="/help"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/help" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={help} alt="" />
                <span>Help & Support</span>
              </a>
  
              <a
                href="#"
                onClick={handleLogout}
                className="aside-menu hover:bg-red-200 rounded-xl text-red-600"
              >
                <img src={logout} alt="" />
                <span>Logout</span>
              </a>
            </nav>
  
            {/* Footer */}
            <div className="copy-rights text-center">
              <p className="copy-rights-app text-xs text-center text-[#095228]">
                &copy; 2025 Pipaan. All Rights Reserved
              </p>
            </div>
          </div>
        </aside>
      </div>
    );
}
